import Event from '@/models/Event'

const ADAS_CATEGORY_ID = 3
const DSM_CATEGORY_ID = 3

export default class EventTransformer {
    transform (data) {
        return new Event(
            data.id,
            data.triggerOn,
            data.deviceModelId,
            data.hardwareId,
            data.eventTypes,
            data.eventCategories,
            data.eventClassification,
            data.locations,
            data.speedPoints,
            data.headingPoints,
            data.isAccident,
            data.speedLimit,
            data.maxSpeed,
            data.speed,
            data.gSensorFrames,
            data.gyroscopeFrames,
            data.address,
            data.eventStatus,
            data.alarmKey,
            data.fromAlarm,
            data.vendorEventType,
            data.organizationId,
            data.organizationName,
            data.fleetId,
            data.fleetName,
            data.vehicleId,
            data.vrn,
            data.driverId,
            data.driverName,
            data.eventCategories.includes(ADAS_CATEGORY_ID),
            data.eventCategories.includes(DSM_CATEGORY_ID)
        )
    }
}
